export enum BrowseProvider {
  NAME = 'browse_provider',
  GOOGLE = 'google_retail',
  LOOP54 = 'loop54',
}
